export const reDirections = [
  {
    currentUrl: "/",
    redirectUrl: "/document",
    redirectUrlAdmin: "/company",
  },
];

export const ADMIN_PAGES = ["/company"];
export const SHARED_PAGES = ["/users", "/profile", "/settings", "/dashboard"];
